// ======================================================================
// FILE: src/modules/wms/dashboard/components/UpcomingScheduleCard.jsx
// MODULE: Work Management System (WMS)
// PURPOSE:
//   Upcoming Recurring Work Schedule
// ======================================================================

import React from "react";

export default function UpcomingScheduleCard({
  data = [],
}) {

  const rows = Array.isArray(data)
    ? data
    : [];

  const formatDate = (value) => {

    if (!value) {
      return "—";
    }

    const parts = value.split("-");

    if (parts.length !== 3) {
      return value;
    }

    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  };


  return (

    <div className="card shadow-sm mb-4">

      <div className="card-header bg-white d-flex justify-content-between align-items-center">

        <h5 className="mb-0">
          Upcoming Schedule
        </h5>

        <span className="badge bg-primary">
          {rows.length} Scheduled
        </span>

      </div>


      <div
  className="table-responsive"
  style={{
    maxHeight: "400px",
    overflowY: "auto",
    overflowX: "auto",
  }}
>

    <table className="table table-hover table-bordered align-middle mb-0">

          <thead
  className="table-light"
  style={{
    position: "sticky",
    top: 0,
    zIndex: 2,
  }}
>

            <tr>

              <th>
                Recurring Work
              </th>

              <th>
                Executor
              </th>

              <th className="text-center">
                Frequency
              </th>

              <th className="text-center">
                Execution Time
              </th>

              <th className="text-center">
                Next Run
              </th>

              <th className="text-center">
                Last Run
              </th>

              <th className="text-center">
                Status
              </th>

            </tr>

          </thead>


          <tbody>

            {rows.length === 0 ? (

              <tr>

                <td
                  colSpan="7"
                  className="text-center text-muted py-4"
                >
                  No upcoming recurring schedules
                </td>

              </tr>

            ) : (

              rows.map((row, index) => (

                <tr
                  key={
                    row.id
                    || index
                  }
                >

                  <td>

                    <strong>
                      {row.scheduleName || "—"}
                    </strong>

                  </td>


                  <td>
                    {row.executor || "—"}
                  </td>


                  <td className="text-center">

                    <span className="badge bg-info text-dark">
                      {row.frequency || "—"}
                    </span>

                  </td>


                  <td className="text-center">

                    {row.executionTime || "—"}

                  </td>


                  <td className="text-center">

                    <strong>
                      {formatDate(row.nextRunDate)}
                    </strong>

                  </td>


                  <td className="text-center">

                    {formatDate(row.lastRunDate)}

                  </td>


                  <td className="text-center">

                    <span className="badge bg-success">
                      {row.status || "ACTIVE"}
                    </span>

                  </td>

                </tr>

              ))

            )}

          </tbody>

        </table>

      </div>

    </div>

  );
}